<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini" :model="searchForm">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="queryTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
       <!-- <el-form-item label="所属小队:" >
          <el-select v-model="searchForm.teamOrgId" filterable placeholder="请选择" clearable >
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center
      border :cell-style="setCellStyle" :span-method="objectSpanMethod" @cell-click="handleCellClick">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="type" width="" label="车辆车辆分类"></el-table-column>
        <el-table-column prop="liquidatedAmount" width="" label="业务量"></el-table-column>
        <el-table-column prop="ydzs" width="" label="趟次"></el-table-column>
        <el-table-column prop="grossRevenue" width="" label="收入"></el-table-column>
        <el-table-column prop="freightAmountTotal" width="" label="成本"></el-table-column>
        <el-table-column prop="ml" width="" label="毛利"></el-table-column>
        <el-table-column prop="mll" width="" label="毛利率"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findBaseTransportationShare } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { organizationTree } from '@/api/vgs-driver2.0'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      queryTime: [],
      searchForm: {

      },
      tableList: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      XDList: [],
      isDaoChu: false,
      summary: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/chelianglayunzhanbi')
    // organizationTree({ flag: 1 }).then((res) => {
    //   if (res[0].orgType == 1) {
    //     this.XDList = res[0].children
    //   } else {
    //     this.XDList = res
    //   }
    // })
    this.initQueryTime()
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    getLastMonthRange () {
      const end = new Date()
      // 设置结束时间为当天的 23:59:59
      const start = new Date()
      start.setDate(start.getDate() - 30)
      // 设置开始时间为当天的 00:00:00
      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },

    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    initQueryTime () {
      const { startTime, endTime } = this.getLastMonthRange()
      this.queryTime = [startTime, endTime]
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 合计行样式
      if (row._isSummary) {
        const style = {
          color: '#1890ff',
          fontWeight: 'bold',
          background: '#f5f7fa'
        }
        // 三个业务量合计列添加指针样式
        if (['allBusinessVolume', 'oneselfLiquidatedAmount', 'outsourceLiquidatedAmount'].includes(column.property)) {
          style.cursor = 'pointer'
          style.color = '#409eff'
        }
        return style
      }
      return null
    },
    // 合计单元格点击
    handleCellClick (row, column, cell, event) {
      if (!row._isSummary) return
      // 页面跳转
      this.$router.push({
        name: 'chelianglayunzhanbiDetail',
        query: {
          source: 'chelianglayunzhanbi',
          startTime: this.searchForm.startTime,
          endTime: this.searchForm.endTime
        }
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 合计行不参与合并
      if (row._isSummary || rowIndex >= this.spanArr.length) {
        return [1, 1]
      }
      if (column.property === 'dayName') {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    // 生成合并规则数组
    getSpanArr (data) {
      this.spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          if (item.dayName === data[index - 1].dayName) {
            this.spanArr[pos] += 1
            this.spanArr.push(0) // 0表示该行被合并
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    masterList () {
      if (!this.queryTime) {
        this.$message.error('请先选择时间')
        return
      }
      this.$set(this.searchForm, 'startTime', this.queryTime[0])
      this.$set(this.searchForm, 'endTime', this.queryTime[1])
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findBaseTransportationShare(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()

          this.tableList = res.list
          this.getSpanArr(this.tableList)
          this.tableList.push({
            type: '合计',
            liquidatedAmount: res.allLiquidatedAmount,
            ydzs: res.allYdzs,
            grossRevenue: res.allArossRevenue,
            freightAmountTotal: res.allFreightAmountTotal,
            ml: res.allMl,
            mll: res.allMll,
            _isSummary: true
          })
          this.tableList.push({
            type: '自有车占比',
            liquidatedAmount: res.zb,
            ydzs: null,
            grossRevenue: null,
            freightAmountTotal: null,
            ml: null,
            mll: null,
            _isSummary: true
          })
          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.initQueryTime()
      this.searchFrom = {}
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      if (!this.queryTime) {
        this.$message.error('请先选择时间')
        return
      }
      this.$set(this.searchForm, 'startTime', this.queryTime[0])
      this.$set(this.searchForm, 'endTime', this.queryTime[1])
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/reportw/exportBaseTransportationShare',
        form,
        '基地仓拉运占比'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
